export default __webpack_public_path__ + "static/media/RaviFull.d98a2042.webp";